import { render } from "./ValidateAccountView.vue?vue&type=template&id=f3c78578&scoped=true"
import script from "./ValidateAccountView.vue?vue&type=script&lang=js"
export * from "./ValidateAccountView.vue?vue&type=script&lang=js"

import "./ValidateAccountView.vue?vue&type=style&index=0&id=f3c78578&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3c78578"]])

export default __exports__